import { useLayoutEffect, useRef } from 'react';

/**
 * Fade-in + rise 24px once the element scrolls into view.
 * Elements already in view on mount, and users with reduced motion, get no animation.
 */
export default function Reveal({ as: Tag = 'div', className = '', children, ...rest }) {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window) || el.getBoundingClientRect().top < window.innerHeight) {
      el.classList.add('no-anim');
      return undefined;
    }
    const io = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) { el.classList.add('is-visible'); io.disconnect(); } }),
      { rootMargin: '0px 0px -6% 0px' }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return <Tag ref={ref} className={`reveal ${className}`} {...rest}>{children}</Tag>;
}
